export default "__VITE_ASSET__A0opRHYM__"